import React__default, { useMemo, createContext, useContext } from 'react';
import baseTheme from './theme/base.esm.js';
import nextTheme from './theme/next.esm.js';

var ThemeContext = /*#__PURE__*/createContext({});
function ThemeProvider(props) {
  var children = props.children,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'base' : _props$theme;
  var value = useMemo(function () {
    return theme === 'base' ? {
      theme: baseTheme
    } : {
      theme: nextTheme
    };
  }, [theme]);
  return /*#__PURE__*/React__default.createElement(ThemeContext.Provider, {
    value: value
  }, children);
}
function useTheme() {
  var _useContext;
  var theme = (_useContext = useContext(ThemeContext)) === null || _useContext === void 0 ? void 0 : _useContext.theme;
  return theme || baseTheme;
}
function useComponentTheme(component) {
  var theme = useTheme();
  return theme.components[component];
}

export { ThemeProvider, useComponentTheme };
//# sourceMappingURL=theme.context.esm.js.map
